import { render, staticRenderFns } from "./ActionHistoryModal.vue?vue&type=template&id=0b484d88"
import script from "./ActionHistoryModal.vue?vue&type=script&lang=ts"
export * from "./ActionHistoryModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports